import Image from "next/image";
import React from "react";
import styles from "./PageHeader.module.scss";
import horizontalLogo from "@public/horizontal-color-cropped.png";
import { LINKS } from "@/constants/links.constant";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  documentationLink?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  documentationLink = LINKS.DOC.GENERAL,
}) => {
  return (
    <div className={styles.pageHeader}>
      <h2 className={styles.titleContainer}>
        <Image src={horizontalLogo} alt="logo" height={60} />
        <span className={styles.highlighted}> {title}</span>
      </h2>
      {subtitle && (
        <div className={styles.subtitleContainer}>
          <p className={styles.subtitle}>
            {subtitle} <br />
            {documentationLink && (
              <>
                {" "}
                To learn more, see our{" "}
                <a href={documentationLink} className={"link"}>
                  documentation
                </a>
                .
              </>
            )}
          </p>
        </div>
      )}
    </div>
  );
};

export default PageHeader;
